import React from 'react';

import { Media } from '$partials/media';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').ColumnQuoteMediaBlock}
 */
const ColumnQuoteMedia = ({
    autoplay,
    backgroundColor,
    media,
    quote,
    richText,
    richTextCaption
}) => {
    const bgColor = `bg-surface-panel-${backgroundColor}`;

    return (
        <section className={`col-wrapper-breakout ${bgColor} rounded-lg pt-16 md:pt-24 pb-16 flex flex-wrap`}>
            <div className='col-padding w-full sm:w-6/12 content-center'>
                <h2 className='type-style-serif-h2 max-w-[550px]'>
                    {quote}
                </h2>

                {richText && (
                    <div
                        className='rich-text mt-16 max-w-[560px]'
                        dangerouslySetInnerHTML={{__html:richText}} />
                )}
            </div>

            <div className='col-padding w-full sm:w-6/12 flex flex-col mt-16 sm:mt-0'>
                <figure className={`rounded-lg overflow-hidden ${media.image ? 'h-[193px]' : 'h-auto' } sm:h-[268px] md:h-[380px]`}>
                    <Media {
                        ...{
                            ...media,
                            ...(media.image ? {
                                image: {
                                    ...media?.image,
                                    className: 'h-full w-full object-cover',
                                    containerStyle: {
                                        height: '100%'
                                    },
                                    containerClassName: 'rounded-lg overflow-hidden pointer-events-none select-none'
                                }
                            } : {}),
                            ...(media.videoEmbed ? {
                                videoEmbed: {
                                    ...media.videoEmbed,
                                    autoPlay: autoplay,
                                    poster: media?.videoEmbed?.poster || media?.videoEmbed?.embed?.thumbnailUrl
                                }
                            } : {} ),
                            ...(media.video ? {
                                video: {
                                    ...media.video,
                                    autoPlay: autoplay,
                                    showControls: !autoplay,
                                    loop: autoplay,
                                }
                            } : {} )
                        }
                    }/>
                </figure>

                {richTextCaption && (
                    <figcaption
                        className='rich-text type-style-sans-body mt-8 w-full md:w-4/6 module-caption'
                        dangerouslySetInnerHTML={{__html:richTextCaption}} />
                )}
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ColumnQuoteMedia;
